import { Parent } from './../../shared/class/parent.model';
import { AuthService } from 'src/app/services/auth.service';
import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent extends Parent implements OnInit {
  public uid: string = null;
  constructor(public authService: AuthService) {
    super();
    this.uid = <string>JSON.parse(sessionStorage.getItem('uid'));
    if(!this.uid){
       window.location.href = '/login';
    }
  }

  ngOnInit() {
  }

  /* Cerrar sesion cuando se cierra la pestaña */
  @HostListener("window:onbeforeunload",["$event"])
  clearLocalStorage(event){
      sessionStorage.clear();
      localStorage.clear();
  }
  
}
